<!--<div>
    <canvas baseChart [chartType]="'pie'" [options]="pieOptions" [datasets]="pieData.datasets" [colors]="pieColors" [labels]="pieData.labels" [legend]="false" height="120"></canvas>
</div>-->
<div *ngIf="!emptyChart">
    <canvas baseChart [chartType]="'pie'" [options]="pieOptions" [datasets]="pieData.datasets" [colors]="pieColors" [labels]="pieData.labels" [legend]="showLegends" height="90"></canvas>
</div>
<div *ngIf="emptyChart">
    <canvas baseChart [chartType]="'pie'" [options]="emptyPieChartOptions" [datasets]="pieData.datasets" [colors]="emptyChartColor" [labels]="pieData.labels" [legend]="showLegends" height="90"></canvas>
</div>